// src/App.tsx
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import ExternalSign from "./pages/ExternalSign";
import Success from "./pages/Success";
import CreateSign from "./pages/createsign";
import ViewSignature from "./pages/viewsign";
import UploadSign from "./pages/UploadSign"; // ← Now used!

function App() {
  return (
    <Routes>
      {/* Home */}
      <Route path="/" element={<Home />} />

      {/* External signing link */}
      <Route path="/sign/:id" element={<ExternalSign />} />
      <Route path="/success" element={<Success />} />

      {/* Internal pages */}
      <Route path="/createsign" element={<CreateSign onSignatureCreated={function (signatureImageUrl: string): void {
        throw new Error("Function not implemented.");
      } } />} />
      <Route path="/viewsign" element={<ViewSignature />} />
      <Route path="/uploadsign" element={<UploadSign />} /> {/* ← Correct path & component */}



      {/* Catch-all: redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
